//React
import { useEffect, useState } from 'react';
//Components
import Layout from '../../hocs/Layout';
import { ShopCard } from '../../components/cards/ShopCard';
import { Link, useSearchParams, useLocation, useNavigate } from 'react-router-dom';
//Redux
import { useSelector } from 'react-redux';
import { get_items, get_total, get_item_total, add_item } from '../../redux/actions/cart';
import { get_search_products } from '../../redux/actions/products';
import { connect } from 'react-redux';
//Styles
import '../../styles/products.css';
//Icons
import { FaAngleRight, FaAngleLeft } from "react-icons/fa6";


const Search = ({
	get_search_products,
	search_products,
	get_items,
	get_total,
	get_item_total,
	add_item
}) => {

	const [searchParams] = useSearchParams();
	const [page, setPage] = useState(1);
	const productsState = useSelector(state => state.Products);

	useEffect(() => {
		window.scrollTo(0,0)
	}, []);

	useEffect(() => {
    get_search_products(searchParams.get("search"), page)	
}, [searchParams, page])

	const addToCart = async (product) => {
	    if (product && product !== null && product !== undefined && product.quantity > 0) {
	        await add_item(product);
	        await get_items();
	        await get_total();
	        await get_item_total();
	    }
	}

	const handleNextPage = () => {
        if (productsState.next) {
            setPage(page + 1);
        }
    };

    const handlePreviousPage = () => {
        if (productsState.previous && page > 1) {
            setPage(page - 1);
        }
    };

	const showProducts = () => {
		let items = [];

        items = Array.isArray(search_products) && search_products.length > 0 ? search_products : [];

		if (items.length > 0) {
        	return items.map((product, index) => (
            	<div key={index} className='product-card-wrapper'>
                	<ShopCard product={product} addToCart={addToCart} />
            	</div>
        	));
    	} else {
        	return <p>No se encontraron resultados de tu búsqueda</p>;
    	}
	}

	return (
		<Layout>
			<div className='container-banner-all shop'>
				<h3>Resultados de tu búsqueda</h3>
			</div>
			<div className='container-product-pagination'>
				<div className='container-shop'>
					{search_products && showProducts()}
				</div>
				<div className="pagination-controls">
                	<button className='pagination-button' onClick={handlePreviousPage} disabled={!productsState || (productsState.previous === null&& page === 1)}>
                    	<FaAngleLeft className='pagination-button-icon' />Anterior
                	</button>
                	<button className='pagination-button' onClick={handleNextPage} disabled={!productsState || productsState.next === null}>
                    	Siguiente <FaAngleRight className='pagination-button-icon' />
                	</button>
            	</div>
			</div>
		</Layout>
	);
};

const mapStateToProps = state => ({
	search_products: state.Products.search_products
})

export default connect(mapStateToProps, {
	get_items,
	get_total,
	get_item_total,
	add_item,
	get_search_products
}) (Search)